<template lang="pug">
  .crud
    modal-purchase-requisitions-prop(:id="newRecord.id")
    modal-purchase-requisitions-detail(:detail='detail', :index='index', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ getTitle() }}:
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button#saveRecord.vm-con-loading__container(icon="save-outline" :disabled="!enabledSave && $v.newRecord.$invalid || newRecord.status != '1'" @click="saveRecord") {{ $t('strings.save') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(@click="editPurchaseRequisitionsDetail(data[indextr], indextr)")
                  vm-icon(icon="edit-2-outline")
                  slot &nbsp;{{ $t('strings.edit') }}
                vm-dropdown-item.d-flex.justify-content-between(@click="deletePurchaseRequisitionsDetailConfirm(data[indextr], indextr)")
                  vm-icon(icon="trash-2-outline")
                  slot &nbsp;{{ $t('strings.delete') }}
                  //- More options
                      vm-dropdown-item.d-flex.justify-content-between(v-if="newRecord.status == '1'" @click="setActionPurchaseRequisition(newRecord, 'send')")
                        vm-icon(icon=checkmark-circle-outline)
                        slot &nbsp;{{ ('strings.send') }}
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-row.form(vm-align="center" vm-type="flex" vm-w="12")
            vm-col(vm-justify="center", vm-align="center", vm-lg=6)
              b-form-group
                vm-select(url="users" column="name" createObject @create-object="newObjectFuncView" autocomplete :placeholder='$t("purchase_requisitions.user_placeholder")' :danger="!$v.newRecord.user_id" :danger-text="'user is required'" v-model="newRecord.user_id" :label='$t("purchase_requisitions.user")' type='number')
                  vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in purchaseRequisitionsCatalog.users")
          vm-tabs
            vm-tab(vm-label="Details" vm-alignment="fixed")
              vm-table(multiple v-model="selected"  max-height="350px" :data="newRecord.details")
                template(slot="header")
                  .d-flex.justify-content-between
                    div
                    div
                      vm-tooltip(:text="$t('strings.addDetail')" delay=".5s")
                        vm-button(size="small" icon="plus" @click="addPurchaseRequisitionDetail" :disabled="newRecord.status != '1'")
                template(slot="thead")
                  vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_requisitions_detail.' + column) }}
                  vm-th
                template(slot-scope="{data}")
                  vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                    vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                      slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                      slot(v-if="column != 'status' && column != 'amount' && column != 'total'") {{data[indextr][column]}}
                      slot(v-if="column == 'status'") {{data[indextr]['status_display']}}
                    vm-td
                    vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                      vm-dropdown-menu
                        vm-dropdown-item.d-flex.justify-content-between(@click="editPurchaseRequisitionDetail(data[indextr], indextr)")
                          vm-icon(icon="edit-2-outline")
                          slot &nbsp;{{ $t('strings.edit') }}
                        vm-dropdown-item.d-flex.justify-content-between(@click="deletePurchaseRequisitionDetailConfirm(data[indextr], indextr)")
                          vm-icon(icon="trash-2-outline")
                          slot &nbsp;{{ $t('strings.delete') }}
                        //- More actions
              vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" vm-w="12")
                vm-col(vm-w=6)
                  vm-row(vm-align="flex-end" vm-type="flex" vm-justify="flex-end" style="text-align: right;")
                    vm-col
                      b Total:&nbsp;&nbsp;
                      span(style="font-size: 1.4rem;") {{ total | currency }}
    transition(name="enter")
      .footer(v-if="enabledSave &\ \!$v.newRecord.$invalid")
        vm-button(type="flat" text-color="#fff" color="rgb(190, 142, 241)" @click="cancel") {{ $t('strings.cancel') }}
        vm-button(type="default" @click="saveRecord") {{ $t('strings.save') }}
</template>

<script>
import ModalPurchaseRequisitionsProp from '@/components/modals/ModalPurchaseRequisitionsProp.vue'
import ModalPurchaseRequisitionsDetail from '@/components/modals/ModalPurchaseRequisitionsDetail.vue'
import { required, numeric } from 'vuelidate/lib/validators' // Ver documentacion
import parseDeleteMany from '@/utils/parseDeleteMany'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseRequisitions')

export default {
  name: 'PurchaseRequisitionsDetail',
  components: {
    ModalPurchaseRequisitionsDetail,
    ModalPurchaseRequisitionsProp
  },
  props: {
    isAdd: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    newRecord: {
      status: 1,
      details: []
    },
    isModalAdd: true,
    detail: {},
    index: 0,
    selected: [],
    enabledSave: false,
    columns: [
      'product',
      'quantity',
      'unit_price',
      'unit_measurement',
      'inventory_sku'
    ],
    status: [
      // Agregar los estatus si maneja
      // {
      //   text: 'Pagado',
      //   value: 2,
      //   color: 'warning'
      // }
    ]
  }),
  validations: {
    newRecord: {
      user_id: {
        required,
        numeric
      }
    }
  },
  async created () {
    this.initPurchaseRequisition(this.newRecord)
    this.$route.params.id && await this.getPurchaseRequisition()
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'initPurchaseRequisition',
      'addPurchaseRequisition',
      'editPurchaseRequisition',
      'deletePurchaseRequisitions',
      'deletePurchaseRequisitionDetail',
      'deletePurchaseRequisitionDetails',
      'actionPurchaseRequisition',
      'loadPurchaseRequisition',
      'loadCatalog',
      'setModalVisible',
      'printReportRecord'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === code)['color']
    },
    getTitle () {
      return this.isAdd ? this.$t('purchase_requisitions.add') : this.$t('purchase_requisitions.edit')
    },
    addPurchaseRequisitionDetail () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.detail = {}
    },
    editPurchaseRequisitionDetail (detail, index) {
      this.isModalAdd = false
      this.setModalVisible(true)
      this.detail = { ...detail }
      this.index = index
    },
    async saveRecord () {
      if (!this.enabledSave) return
      this.enabledSave = false
      let t = this
      this.$vm.loading({
        background: 'primary',
        color: '#fff',
        container: '#saveRecord',
        scale: 0.45
      })
      await this.isAdd ? this.addPurchaseRequisition(this.newRecord).then(() => { t.$router.push({ name: 'purchaseRequisitions' }) }) : this.editPurchaseRequisition(this.newRecord).then(() => { t.$router.push({ name: 'purchaseRequisitions' }) })
    },
    async deletePurchaseRequisitionConfirm (purchaseRequisition) {
      let t = this
      this.auxDeletePurchaseRequisition = () => {
        t.deletePurchaseRequisition(purchaseRequisition).then(() => { t.$router.push({ name: 'purchaseRequisitions' }) })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.purchase_requisition'), attribute: this.$t(purchaseRequisition.amount) }),
        accept: this.auxDeletePurchaseRequisition
      })
    },
    async deletePurchaseRequisitionDetailConfirm (detail, index) {
      let t = this
      this.auxDeletePurchaseRequisitionDetail = () => {
        t.deletePurchaseRequisitionDetail({ detail, index }).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.purchase_requisition'), attribute: detail.id ? detail.id : index }),
        accept: this.auxDeletePurchaseRequisitionDetail
      })
    },
    async deletePurchaseRequisitionDetailsConfirm () {
      let t = this
      let purchaseRequisitionsMany = parseDeleteMany(this.selected, 'id')
      this.auxDeletePurchaseRequisitionDetail = () => {
        t.deletePurchaseRequisitionDetails(purchaseRequisitionsMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.purchase_requisition'), attribute: purchaseRequisitionsMany.indexes }),
        accept: this.auxDeletePurchaseRequisitionDetail
      })
    },
    async setActionPurchaseRequisition (record, action) {
      let t = this
      this.auxActionPurchaseRequisition = () => {
        t.actionPurchaseRequisition({ id: record.id, action })
      }
      this.dialog({
        color: 'warning',
        title: this.$t('strings.purchase_requisition'),
        text: this.$t('front.action_confirmation', { model: this.$t('strings.purchase_requisition'), action: this.$t('purchase_requisitions.' + action) }),
        accept: this.auxActionPurchaseRequisition
      })
    },
    async getPurchaseRequisition (page) {
      this.loadPurchaseRequisition(this.$route.params)
    },
    async getCatalog () {
      Object.keys(this.purchaseRequisitionsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    printRecord (record) {
      this.setModalPropVisible(true)
    },
    autoCompleteFunc (value) {
      let payload = {}
      let column = value.target.parentElement.parentElement.getAttribute('column')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?${column}=${param}*&order_by=${column},asc`
      this.loadCatalog(payload)
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    cancel () {
      this.$router.push({ name: 'purchaseRequisitions' })
    }
  },
  computed: {
    ...mapGetters([
      'purchaseRequisition',
      'purchaseRequisitionsCatalog'
    ]),
    detailsLength () {
      return this.newRecord.details.length
    },
    enabledEdit () {
      return this.newRecord.id
    }
  },
  watch: {
    newRecord (record) {
      Object.keys(record).length > 2 ? this.enabledSave = true : this.enabledSave = false
    },
    purchaseRequisition (purchaseRequisition) {
      this.newRecord = { ...purchaseRequisition }
    },
    'purchaseRequisition.details' (details) {
      this.newRecord.details = []
      details.map(e => this.newRecord.details.push({ ...e }))
      this.newRecord.amount = this.amount
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.form {
  padding: 20px 10px 0;
}
.con-vm-tooltip {
  display: inline-block;
  float: left;
  position: relative;
}
.con-vm-tabs {
  padding: 10px;
  .vm-tabs--ul {
    box-shadow: none;
  }
  .vm-tabs--content {
    padding: 0;
  }
}
.vm-col {
  padding: 0 10px;
}
.vm-table--header {
  padding: 0px !important;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
          display: block;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
